import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireLinkClickedEvent } from '../../utils/analytics/click';
export let ClickButton = /*#__PURE__*/function (ClickButton) {
  ClickButton[ClickButton["Left"] = 0] = "Left";
  ClickButton[ClickButton["Middle"] = 1] = "Middle";
  ClickButton[ClickButton["Right"] = 2] = "Right";
  return ClickButton;
}({});
export const useLinkClicked = (handler, predicate) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  return useCallback((...args) => {
    const [event] = args;
    handler === null || handler === void 0 ? void 0 : handler.apply(null, args);
    if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) {
      fireLinkClickedEvent(createAnalyticsEvent)(event);
    }
  }, [handler, predicate, createAnalyticsEvent]);
};
const isNotLeftClick = event => event.button !== 0;
export const useMouseDownEvent = onMouseDown => {
  return useLinkClicked(onMouseDown, isNotLeftClick);
};